import React, {useState, useEffect} from "react";

export default function GetCustomers(){

  const [Customers, SetCustomers] = useState([]);

    useEffect(() => {
      const fetchCustomers = async () => {
        const result = await fetch(import.meta.env.VITE_URL + '/customers.json');
        const jsonresult = await result.json()
        SetCustomers(jsonresult)
      }
      fetchCustomers();
    }, [])

    return Customers
}
